import { render, staticRenderFns } from "./LatestLeaderboard.vue?vue&type=template&id=7e851626&scoped=true"
import script from "./LatestLeaderboard.vue?vue&type=script&lang=js"
export * from "./LatestLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./LatestLeaderboard.vue?vue&type=style&index=0&id=7e851626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e851626",
  null
  
)

export default component.exports